import React, { useMemo } from "react";
import PropTypes from "prop-types";
import { Bar } from "react-chartjs-2";
import { defaultOptions, defaultPlugins, defaultRootPlugins } from "./config";

const DEFAULT_STYLING = { barThickness: 40, borderRadius: 5, borderSkipped: "middle", borderWidth: 0 };

const RatioChart = ({ data, title, parser }) => {
  const parsing = { xAxisKey: parser.x, yAxisKey: parser.y };

  const formattedData = useMemo(() => {
    const datasets = [];

    data.forEach((d) => {
      const set = { label: d[parser.x], data: [ d[parser.y] ], ...DEFAULT_STYLING };
      if (d.color) {
        set.backgroundColor = d.color;
        set.hoverBackgroundColor = d.color;
      }

      datasets.push(set);
    });

    return { labels: [""], datasets };
  }, [ data, parser ]);

  const total = data.reduce((accumulator, value) => (accumulator + value[parser.y]), 0);

  return (
    <Bar
      data={formattedData}
      options={{
        ...defaultOptions,
        ...parsing,

        scales: {
          x: { stacked: true, display: false, max: total },
          y: { stacked: true, display: false }
        },

        plugins: { ...defaultPlugins, title },
        layout: { padding: { left: 30, right: 30 } },

        indexAxis: "y",
      }}
      plugins={defaultRootPlugins}
    />
  );
};

RatioChart.propTypes = {
  title: PropTypes.string,
  data: PropTypes.array,
  parser: PropTypes.shape({
    x: PropTypes.string,
    y: PropTypes.string,
    xLabel: PropTypes.string,
    yLabel: PropTypes.string,
  }),
};

export default RatioChart;
